import { z } from 'zod';
import { requiredString } from '../../../validation';

export const CareDocumentOvercomeChallengeRecommendationSchema = z.object({
  recommendation: requiredString('Recommendation is required'),
  timeframe: requiredString('Timeframe is required'),
});

export type CareDocumentOvercomeChallengeRecommendation = z.infer<
  typeof CareDocumentOvercomeChallengeRecommendationSchema
>;
